import { render, staticRenderFns } from "./SignUpConfirmCodeComponent.vue?vue&type=template&id=006a6900&scoped=true&"
import script from "./SignUpConfirmCodeComponent.vue?vue&type=script&lang=js&"
export * from "./SignUpConfirmCodeComponent.vue?vue&type=script&lang=js&"
import style0 from "./SignUpConfirmCodeComponent.vue?vue&type=style&index=0&id=006a6900&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "006a6900",
  null
  
)

export default component.exports